export default __webpack_public_path__ + "static/media/arrow_down_thin.2ed8b49d.svg";